import { Box, Paper, Stack } from "@mui/material";
import { Asset } from "@shared/ui";
import { PropsWithChildren, ReactNode, useState } from "react";


export interface NavgroupProps extends PropsWithChildren{
    tab: ReactNode
}

export function Navgroup(props: NavgroupProps){
    const [isMenuOpen, setIsMenuOpen] = useState(false) 
    return (
        <Box
            onMouseEnter={
                () => {
                    setIsMenuOpen(true)
                }
            }
            onMouseLeave={
                () => {
                    setIsMenuOpen(false)
                }
            }
            sx={{
                position: 'relative'
            }}
        >
            <Stack 
                direction={'row'}
                gap={"2px"}
                alignItems={'center'}
            >
                {props.tab}
                <Asset 
                    imgProps={{
                        alt: 'message type icon',
                        style: {
                            transform: `rotate(${isMenuOpen ? 180 : 0}deg)`,
                        }
                    }}
                    namespace="icons" 
                    filename={'dropdown.svg'}
                    h={16}
                    w={16}
                />
            </Stack>
            {
                isMenuOpen && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '26px',
                            left: `-75%`,
                            zIndex: 1
                        }}
                    >
                        <Paper
                            elevation={1}
                            sx={{
                                p: '15px'
                            }}
                        >
                            {props.children}
                        </Paper>
                    </Box>
                )
            }
        </Box>
    )
}